import { useState } from 'react';

import { Card, Col, Row, Button, Divider, Collapse } from 'antd';

import MintForm from './Form';
import styles from './FormMobile.module.css';
import Preview from './Preview';

const { Panel } = Collapse;

export default function FormMobile({  form }: any) {
  const [activeKey, setActiveKey] = useState('Form');
  const showPreview = () => {
    setActiveKey('Preview');
  };

  return (
    <Row id="mint-form-mobile" justify="center">
      <Col span={24}>
        <Card>
          <Collapse activeKey={activeKey} bordered={false} ghost>
            <Panel className={styles.collapseItem} showArrow={false} header={() => {}} key="Form">
              <MintForm showPreview={showPreview} form={form} isMobile={true} />
            </Panel>
            <Panel className={styles.collapseItem} showArrow={false} header={() => {}} key="Preview">
              <Preview  form={form}/>
              <Divider />
              <Button type="primary" className="w-100 btn-primary mb-1" onClick={form.submit}>
                Mint Token
              </Button>
              <Button type="default" className="w-100 btn-secondary text-white" onClick={(_) => setActiveKey('Form')}>
                Back
              </Button>
            </Panel>
          </Collapse>
        </Card>
      </Col>
    </Row>
  );
}
